import { useCallback, useEffect, useState } from "react";
import { api } from "../../../../lib/api";
import { createLogger } from "../../../../lib/logger";
import { Project } from "../../../../types";

const log = createLogger("useProjectDetails");

export interface UseProjectDetailsResult {
  project: Project | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useProjectDetails(projectId: string): UseProjectDetailsResult {
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProject = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.projects.get(projectId);
      setProject(data.project);
    } catch (err) {
      log.error("Failed to fetch project", err);
      setError(err instanceof Error ? err.message : "Failed to fetch project");
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchProject();
  }, [fetchProject]);

  return {
    project,
    loading,
    error,
    refetch: fetchProject,
  };
}
